import { getIsSerialShown } from '../../helpers/getIsSerialShown';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import PartSerialNumberField from 'pages/MaintenancePage/components/LogServicePanel/components/PartSerialNumberField';
import ServiceDateField from 'pages/MaintenancePage/components/LogServicePanel/components/ServiceDateField';
import ServiceNotesField from 'pages/MaintenancePage/components/LogServicePanel/components/ServiceNotesField';
import ServicePhotosField from 'pages/MaintenancePage/components/LogServicePanel/components/ServicePhotosField';
import { getServiceRecordSummary } from 'pages/MaintenancePage/helpers/getServiceRecordSummary';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const EditServiceForm: FunctionComponent<Props> = ({
    className = '',
    draft,
    onAddPhotos,
    onChangeNotes,
    onChangePartSerialNumber,
    onChangePerformedAt,
    onRemovePhoto,
    record,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    return (
        <VerticalContainer className={`${styles.editServiceForm} ${className}`} testId={testId}>
            <Wrapper className={styles.summary}>
                {getServiceRecordSummary({ record, strings: t })}
            </Wrapper>

            {getIsSerialShown({ record }) && (
                <PartSerialNumberField
                    className={styles.field}
                    onChange={onChangePartSerialNumber}
                    partSerialNumber={draft.partSerialNumber}
                />
            )}

            <ServiceDateField
                className={styles.field}
                onChange={onChangePerformedAt}
                value={draft.performedAt}
            />

            <ServiceNotesField
                className={styles.field}
                notes={draft.notes}
                onChange={onChangeNotes}
            />

            <ServicePhotosField
                className={styles.field}
                onAddPhotos={onAddPhotos}
                onRemovePhoto={onRemovePhoto}
                photos={draft.photos}
            />
        </VerticalContainer>
    );
};

export default EditServiceForm;
